var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLongArrowRight = function SvgLongArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 72 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.06 13.06a1.5 1.5 0 0 0 0-2.12l-9.545-9.547a1.5 1.5 0 1 0-2.122 2.122L67.88 12l-8.486 8.485a1.5 1.5 0 1 0 2.122 2.122zM0 13.5h70v-3H0z"
  })));
};
export default SvgLongArrowRight;